import type FolderId from "../state/FolderId";
import type { Form } from "../state/form";
import type { SelectableIconName } from "../utils/iconUtil";
import { type InferOutput, object, pick } from "valibot";
import { icon, optionalTextValue, requireText } from "../utils/validation/base";
import { MAX_CHARACTERS_MD, MAX_CHARACTERS_SM, SELECTABLE_FOLDER_ICONS } from "../constants";
import { pickSchema } from "../utils/validationUtil";

export type FolderStatus = "ACTIVE" | "HIDDEN" | "UNKNOWN";

export type Folder = {
  id: FolderId;
  forms: Form[];
  status: FolderStatus;
  meta: {
    name: string;
    description?: string;
    icon: SelectableIconName;
  };
};

export const folderSchema = object({
  meta: object({
    name: requireText(MAX_CHARACTERS_SM),
    description: optionalTextValue(MAX_CHARACTERS_MD),
    icon: icon(SELECTABLE_FOLDER_ICONS),
  }),
});

export const createFolderSchema = pick(pickSchema(folderSchema, "meta"), ["name", "description", "icon"]);

export type CreateFolder = InferOutput<typeof createFolderSchema>;
